import { atom } from 'recoil';

import { TaxInfo } from '~/types/cart';

const taxInfo = atom<TaxInfo>({
  key: 'taxInfo',
  default: {
    title: '',
    invoice: '',
  },
});

export default taxInfo;
